<ng-container *ngIf="context">
  <p class="contact">{{ context.row[context.id] }}</p>
  <div class="notification-settings">
    <app-square *ngFor="let badge of badges" [data]="badge" [showTooltip]="true"></app-square>
  </div>
</ng-container>
